import React, { useContext } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {
  Tooltip as BaseTooltip,
  ApproveIcon as BaseApproveIcon,
  ActiveDeclineIcon
} from '@ubeya/shared-web/components';
import { ago } from '@ubeya/shared/utils/time';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Tooltip = styled(BaseTooltip)`
  margin-left: 20px;
  .rc-tooltip-inner {
    max-width: 200px;
    text-align: center;
  }
`;

const ApproveIcon = styled(BaseApproveIcon)`
  min-width: 26px;
`;

const EmployeeTimesheetResponseStatus = ({ rowData: { employeeApproved, employeeDeclined } }) => {
  const { dateFormat, timeFormat } = useContext(ConfigContext);
  const { t } = useContext(ConfigContext);

  if (!employeeApproved && !employeeDeclined) {
    return <></>;
  }

  const { createdAt } = employeeApproved || employeeDeclined;

  const timeAgo = createdAt
    ? `${ago(createdAt, t)} (${moment(createdAt).format(dateFormat)} ${moment(createdAt).format(timeFormat)})`
    : '';

  const tooltip = `${t(
    employeeApproved
      ? 'employeeApprovedTimesheet'
      : `${t('employeeDeclinedTimesheetReason')}: ${employeeDeclined.reason}`
  )}, ${timeAgo}`;

  return (
    <Wrapper>
      <Tooltip body={tooltip}>{employeeApproved ? <ApproveIcon $isActive /> : <ActiveDeclineIcon />}</Tooltip>
    </Wrapper>
  );
};

export default EmployeeTimesheetResponseStatus;
